import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'
import { Provider } from 'react-redux'
import { store } from '@store/store'
import { ThemeProvider } from '@config/theme.config'
import { isProd } from '@config/environment.config'

if (isProd && false) {
  // @ts-ignore
  import('./sentryInstrument.ts').catch((err) => {
    console.error('Error loading Sentry instrumentation:', err)
  })
}
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
)
